import {Button, styled, Typography, Box} from '@mui/material'
import FormDatePicker from 'components/Control/Form/FormDatePicker'
import useDownloadsReport from 'logic/Reports/useDownloadsReport'
import {useI18n} from 'store/Store'
import DownloadIcon from '@mui/icons-material/Download'

const DownloadsReport = () => {
    const {i18n} = useI18n()
    const {control, errors, formValues, getDownloadUrl} = useDownloadsReport()

    return (
        <Container>
            <ContentWrapper>
                <Typography variant="h6" gutterBottom>
                    {i18n.t('dashboard.selectDateRange')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{mb: 4}}>
                    {i18n.t('dashboard.downloadsReportDescription')}
                </Typography>

                <FormContainer>
                    <FormDatePicker
                        fullWidth
                        name="from"
                        label={i18n.t('dashboard.from')}
                        control={control}
                        error={errors.from}
                        valueFormat="YYYY-MM-DD"
                    />

                    <FormDatePicker
                        fullWidth
                        name="to"
                        label={i18n.t('dashboard.to')}
                        control={control}
                        error={errors.to}
                        valueFormat="YYYY-MM-DD"
                    />
                </FormContainer>

                <ButtonContainer>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<DownloadIcon />}
                        href={getDownloadUrl()}
                        disabled={!formValues.from || !formValues.to}>
                        {i18n.t('dashboard.download')}
                    </Button>
                </ButtonContainer>
            </ContentWrapper>
        </Container>
    )
}

export default DownloadsReport

const Container = styled(Box)`
    display: flex;
    width: 100%;
`

const ContentWrapper = styled(Box)`
    width: 100%;
    max-width: 700px;
    padding: ${({theme}) => theme.spacing(2, 3)};

    ${({theme}) => theme.breakpoints.down('sm')} {
        padding: ${({theme}) => theme.spacing(2)};
    }
`

const FormContainer = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({theme}) => theme.spacing(3)};
    margin-bottom: ${({theme}) => theme.spacing(4)};

    ${({theme}) => theme.breakpoints.down('sm')} {
        grid-template-columns: 1fr;
        gap: ${({theme}) => theme.spacing(2.5)};
    }
`

const ButtonContainer = styled(Box)`
    display: flex;
    justify-content: center;
`
